export const USER_PROFILE_TAB_CATEGORIES_SCOPE_FILTER_KEY = 'staff_member'

export const USER_PROFILE_TAB_CATEGORIES_QA_NAME = {
  editCategories: 'userProfileTabCategoriesEdit',
  table: 'userProfileTabCategories',
}

export const USER_PROFILE_TAB_CATEGORIES_EXTRA_LIST_PARAMS = {
  with_category_groups: true,
}
